import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[8]};

  .no-results {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    ${font('text', 'md', '400')}
    color: ${color.darkBlue[800]};
    text-align: center;
    padding: ${spacing[12]} ${spacing[0]};
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${spacing[10]};
  ${font('text', 'sm', '600')}
  color: ${color.darkBlue[800]};
  padding: ${spacing[0]} ${spacing[12]};
`;

export const List = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${spacing[0]} ${spacing[0]} ${spacing[12]};
  margin: ${spacing[0]};
  list-style: none;
`;
